import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from '@mui/material';
import React, { useCallback, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { changePassword } from '../../api/auth';

export default function ChangePasswordForm() {
  const navigate = useNavigate();
  const { recoveryCode } = useParams();
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'error',
  });
  const formData = useRef({ password: '', confirmedPassword: '' });

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      const { password } = formData.current;
      setLoading(true);

      const result = await changePassword(password, recoveryCode);
      setLoading(false);

      if (result.isOk) {
        navigate('/login');
      } else {
        setNotification({
          open: true,
          message: result.message,
          severity: 'error',
        });
      }
    },
    [navigate, recoveryCode]
  );

  const confirmPassword = useCallback(
    ({ target: { value } }) => value === formData.current.password,
    []
  );

  return (
    <Paper elevation={3} sx={{ padding: 3, maxWidth: 400, margin: '10% auto' }}>
      <form onSubmit={onSubmit}>
        <Typography variant='h5' textAlign='center' gutterBottom>
          Új jelszó beállítása
        </Typography>
        <TextField
          fullWidth
          label='Jelszó'
          variant='filled'
          type='password'
          required
          onChange={(e) => (formData.current.password = e.target.value)}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label='Jelszó megerősítése'
          variant='filled'
          type='password'
          required
          error={
            formData.current.confirmedPassword &&
            !confirmPassword({
              target: { value: formData.current.confirmedPassword },
            })
          }
          helperText={
            formData.current.confirmedPassword &&
            !confirmPassword({
              target: { value: formData.current.confirmedPassword },
            })
              ? 'A jelszavak nem egyeznek'
              : ''
          }
          onChange={(e) =>
            (formData.current.confirmedPassword = e.target.value)
          }
          sx={{ mb: 2 }}
        />
        <Box textAlign='center' mt={2}>
          <Button
            type='submit'
            variant='contained'
            color='primary'
            fullWidth
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'Folytatás'}
          </Button>
        </Box>
      </form>
      <Snackbar
        open={notification.open}
        autoHideDuration={3000}
        onClose={() => setNotification({ ...notification, open: false })}
      >
        <Alert
          onClose={() => setNotification({ ...notification, open: false })}
          severity={notification.severity}
          variant='filled'
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </Paper>
  );
}
